export default {
  xeroOrganisations: [],
  xeroOrganisation: undefined,
};
